import { ViteSSG } from "vite-ssg";
import App from "@/App.vue";
import { routes } from "@/router";
import "@/index.css";
import mdiVue from "mdi-vue/v3";
import * as mdijs from "@mdi/js";

import "normalize.css/normalize.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

export const createApp = ViteSSG(
  App,
  { routes, base: import.meta.env.BASE_URL },
  ({ app, router, routes, isClient, initialState }) => {
    // 提供 initialState 給所有組件使用（用於 SSG 資料預取）
    app.provide("initialState", initialState);

    app.use(mdiVue, {
      icons: mdijs,
    });

    if (isClient) {
      // In Vue 3, prototype is not recommended, use globalProperties
      app.config.globalProperties.$liff = window.liff;
    }
  },
);
